import { FC, ReactNode } from "react";
import {
  DialogContent as ReachDialogContent,
  DialogOverlay as ReachDialogOverlay,
} from "@reach/dialog";
import { Box, Button, Icon, SystemProps } from "@storyofams/react-ui";
import { motion } from "framer-motion";
import Image from "next/image";
import ReactPlayer from "react-player";
import styled from "styled-components";
import { Cross } from "~components/common/Icons";
import { Slider } from "~components/common/Slider";
const MotionOverlay = motion(ReachDialogOverlay);
const MotionDialog = motion(ReachDialogContent);
const DialogOverlay = styled(MotionOverlay)<SystemProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  backdrop-filter: blur(7px);
  z-index: ${(p) => p.theme.zIndices.modal};

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.5);
  @media (max-width: ${(p) => p.theme.breakpoints.md}) {
    padding: ${(p) => p.theme.space[4]}px ${(p) => p.theme.space[2]}px 92px;
  }
`;

const DialogContent = styled(MotionDialog)<{ children?: ReactNode }>`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 100%;
  background: transparent;
  @media (min-width: ${(p) => p.theme.breakpoints.md}) {
    max-width: 774px;
  }
`;

const CloseButton = styled(Button)`
  position: absolute;
  right: 16px;
  top: -30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 100px;
  transition: color 0.2s;
  z-index: 2;
`;

const ContentWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 auto;
  padding: 0 16px;
  width: max-content;
  height: max-content;
`;
interface ModalProps {
  isOpen: boolean;
  activeIndex: number;
  close: () => void;
  sliderContent: {
    src: string;
    type: string;
  }[];
}
export const Modal: FC<ModalProps> = ({
  sliderContent,
  isOpen,
  activeIndex,
  close,
}) => {
  return (
    <>
      {isOpen && (
        <DialogOverlay
          onDismiss={close}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 1 }}
        >
          <DialogContent
            aria-label={"image-modal"}
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            exit={{ y: -10 }}
          >
            <ContentWrapper
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 1 }}
            >
              <CloseButton
                variant="unstyled"
                onClick={close}
                aria-label="Close modal"
              >
                <Icon icon={Cross} fontSize={2.5} color="grey900" />
              </CloseButton>

              <Box
                width={"800px"}
                bg="white"
                className="slider-container"
                height={["50vh", "800px"]}
                maxHeight={["calc(100vh - 80px)", "100%"]}
                maxWidth={["calc(100vw - 32px)", "100%"]}
                overflow="hidden"
              >
                <Slider initialSlide={activeIndex} perPage={1} isReview>
                  {sliderContent.map(({ src, type }) => (
                    <Box
                      height={["50vh", "800px"]}
                      maxHeight={["calc(100vh - 80px)", "100%"]}
                      maxWidth={["calc(100vw - 32px)", "100%"]}
                      key={src}
                      position={"relative"}
                    >
                      {type === "video" ? (
                        <ReactPlayer
                          url={src}
                          height={"100%"}
                          width={"100%"}
                          playing
                          playsinline
                          muted
                          controls
                          config={{
                            youtube: {
                              playerVars: {
                                controls: true,
                              },
                            },
                          }}
                        />
                      ) : type === "embed" ? (
                        <div dangerouslySetInnerHTML={{ __html: src }}></div>
                      ) : (
                        <Image
                          src={src}
                          objectFit="contain"
                          layout="fill"
                        ></Image>
                      )}
                    </Box>
                  ))}
                </Slider>
              </Box>
            </ContentWrapper>
          </DialogContent>
        </DialogOverlay>
      )}
    </>
  );
};
